export default {
  fetchDistricts ({ commit }, data) {
    commit('SET_DISTRICTS', data.districts)
  },
  addDistrict ({ commit }, data) {
    commit('ADD_ITEM', data.district)
  },
  updateDistrict ({ commit }, data) {
    commit('UPDATE_DISTRICT', data.district)
  },
  removeDistrict ({ commit }, data) {
    commit('REMOVE_ITEM', data.id)
  }
}
